// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2B1o5","list":"BalanceDue_list__hnZvw","listRow":"BalanceDue_listRow__2E9tP","total":"BalanceDue_total__31Cu5"};